import { Component, Input, Output, EventEmitter, HostListener, OnInit, OnChanges, OnDestroy, DoCheck } from "@angular/core";
import { AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { AppEditorServices } from "../../services/app-editor.services";
import { AutoFillServices } from "../../services/autofill.services";

@Component({
  selector: 'auto-fill-2',
  template: require('./auto-fill-2.component.pug'),
  styles: [require('./auto-fill-2.component.scss')]
})

export class AutoFillComponent2 implements OnInit, OnChanges, OnDestroy, DoCheck {
  private suggestion: string;
  private canAddSeveral: boolean;
  private isInput: boolean;
  private type: string;
  private nextId: string;
  private previousId: string;
  private i: number = 0;
  private placeholder: any[] = new Array;
  private id: string;
  private key: string;
  private searchResult: any[] = new Array;
  private terms: object = {};
  private autofillSubscription: any;

  constructor(
    private sanitizer: DomSanitizer,
    private editor: AppEditorServices,
    private autofill: AutoFillServices
   ){
     this.autofillSubscription = this.autofill.onUpdatedAutoFillTerms.subscribe( ( terms: any ) => {
       this.terms = terms;
     } );
   }

  ngOnInit(): void {
  }

  ngOnChanges( changes: any ): void {}

  ngOnDestroy(): void {
    this.autofillSubscription.unsubscribe();
  }

  ngDoCheck(): void {
    const input = document.getElementById( this.id );
    const suggestion = document.getElementById( this.suggestion );
    const nextElement = document.getElementById( this.nextId );
    const previousElement = document.getElementById( this.previousId );
    const metaKey = this.id ? this.id.split( '.' )[ 1 ] : null ;
    const placeholder = this.placeholder.toString();

    if ( this.key === 'escape' ) {
      this.i ++;
      if ( this.i === 1 ) {
        if ( this.isInput ) {
          if ( !this.editor.modelHasKey( metaKey ) || !this.editor.getInputValue( metaKey ) ) {
            input.setAttribute('placeholder', `Enter ${metaKey}`);
            this.searchResult = [];
          }
        }
      }
      input.focus()
    }

    if ( !this.isInput && ( this.key === 'enter' || this.type === 'click' ) ) {
      this.i ++;
      if ( this.i === 1 ) {
        const meta = suggestion.getAttribute('class');
        const canAddSeveral = ( meta === 'names' || meta === 'keywords') ? true : false;

        if ( canAddSeveral ) {
          input.setAttribute('placeholder', `Add: ${placeholder}`);
          this.editor.setInputValue( metaKey, undefined )
        }
        else {
          this.editor.setInputValue( metaKey, placeholder);
          this.placeholder = [];
        }

        this.searchResult = [];
        input.focus();
      }
    }

    if ( this.key === 'arrowright' ) {
      this.i ++;
      const isNamesOrKeywords = (metaKey === 'names' || metaKey === 'keywords');
      const doExecute = ( this.i === 1 && this.isInput && isNamesOrKeywords );
      if ( doExecute ) {
        this.editor.setInputValue( metaKey, placeholder)
      }
    }

    if ( this.key === 'arrowdown' ) {
      if ( nextElement ) nextElement.focus();
    }

    if ( this.key === 'arrowup' ) {
      if ( previousElement ) previousElement.focus();
    }

  }

  @Input( 'inputs' ) inputs: string;

  @HostListener( 'click', ['$event'] ) onClickHandler( event: any ) {
    const { id, nodeName } = event.target;

    if ( nodeName.toLowerCase() !== 'label') {
      const thisId = id ? id : event.target.parentElement.id;
      const metaKey = id.split( '.' )[ 1 ];

      this.type = event.type;
      this.isInput = nodeName === "INPUT" ? true : false;

      if ( !this.isInput ) {
        this.i = 0;
        this.suggestion = thisId;
        this.placeholder.push( thisId );
      }
      else {
        this.id = id;
      }

    }
  }

  @HostListener( 'keyup', ['$event'] ) onKeyUpHandler( event: any ) {
    const { value, name, id, nodeName, previousElementSibling, nextElementSibling } = event.target;
    const metaKey = id.split( '.' )[ 1 ];

    this.type = event.type;
    this.isInput = nodeName === 'INPUT' ? true : false ;
    this.key = event.key.toLowerCase();
    this.isInput ? this.id = id: this.suggestion = id ;

    if ( this.key === 'enter') {
      if ( !this.isInput ) {
        this.i = 0;
        this.placeholder.push( id );
      }
    }

    if ( this.key === 'escape') {
      if ( this.isInput ) {
        this.i = 0;
        this.editor.setInputValue( metaKey, undefined );
        this.placeholder = [];
      }
    }

    if ( this.key === 'arrowright') {
      if ( this.isInput ) {
        this.i = 0;
      }
    }

    if ( this.key === 'arrowup') {
      if ( previousElementSibling ) {
        this.previousId = previousElementSibling.id;
      }
    }

    if ( this.key === 'arrowdown') {
      if ( nextElementSibling ) {
        this.nextId = nextElementSibling.id;
      }
    }

    // PERFORM SEARCH ON INPUT
    if ( this.terms[ metaKey ] ) {
      let tempArray: any = [];
      this.searchResult = [];

      if ( value && !value.match(/[.*+?^${}()|[\]\\]/g)) {
        const regex = new RegExp( value, 'ig' );

        this.terms[ metaKey ].forEach( ( element: any ) => {
          if ( element ) {
            const isMatch = element.match( regex );
            if ( isMatch ) {
              const splitElement = element.split( regex );
              const innerHTML = this.sanitizer.bypassSecurityTrustHtml(`${ splitElement[ 0 ] }<b style="color:red">${ value }</b>${ splitElement[ 1 ] }`);
              const id = element;
              tempArray.push( { id: id, innerHTML: innerHTML } );
            }
          }
        })
      }

      this.searchResult = tempArray.slice(0, 5);
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/components/auto-fill-2/auto-fill-2.component.ts